import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  GridList,
  IconButton,
  GridListTile,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import { useState, useContext } from "react";
import SFDialogTitle from "./SFDialogTitle";

import useOffers from "../hooks/useOfferInfo";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import { Loading } from "ra-ui-materialui";
import CircleToggleButtonItem from "./CircleToggleButton";
import useCheckAuthorizeCode from "../hooks/useCheckAuthorizeCode";
import { useTranslate } from "react-admin";
// import useSFAlert from "../hooks/useSFAlert";
// import { useAlert } from "react-hook-popup";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    // height: 508,
    margin: "0 auto",
    paddingTop: 50,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  paper: {
    margin: 0,
    width: 550,
    // height: 508,
    maxWidth: 667,
    borderRadius:"10px"
    // maxHeight: 508,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    width: "auto",
    alignItems: "center",
  },
  toggleButtonGroup: {},
  toggleButton: {
    width: 180,
    height: 38,
  },
  selected: {
    backgroundColor: "orange!important",
    color: "white!important",
  },
  discountTextField: {
    marginTop: 31,
    width: 426,
    height: 66,
  },
  authorizeTextField: {
    width: 396,
    height: 66,
    marginBottom: 20,
  },
  circleItem: {
    width: 77,
    height: 77,
    borderRadius: 37,
    borderWidth: 1,
    borderColor: theme.orange,
  },
  gridList: {
    width: 350,
    height: "auto",
  },
  circleItemsContainer: {
    display: "grid",
    height: "auto",
    overflow: "auto",
    // display: "flex",
    width: "400px",
    padding: 10,
    marginTop: 17,
    gridTemplateColumns: "33% 33% 34%",
    gridAutoRows: "auto",
    gridGap: 10,
    justifyItems: "center",
    maxHeight: "100%",
    boxSizing: "border-box",
    //  justifyContent: "space-around",
    alignItems: "center",
  },
  circleText: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.orange,
  },
  circleText_selected: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.white,
  },
  circleConditionBadge: {
    width: 44,
    height: 44,
    backgroundColor: theme.orange,
  },
  circleConditionBadgeText: { fontSize: 10, color: theme.white },
  dialogAction: { padding: 0, flexDirection: "column" },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    borderRadius: "0px 0px",
    margin: "0 !important",
  },
}));

const OffersDialog = ({ alert }) => {
  const classes = useStyles();
  const { checkAuth } = useCheckAuthorizeCode();

  //const [alert] = useAlert();
  const [showPassword, setShowPassword] = useState(false);
  const [pin, setPin] = useState("");
  const [offerSelection, setOfferSelection] = useState("");
  const { loading, offers, error } = useOffers();
  const [state, dispatch] = useContext(PaymentCreateContext);
  const [openDiscount, setOpenDiscount] = useState();
  const translate = useTranslate();
  if (loading) return <Loading />;
  if (error) {
    console.error("Offer error");
    return null;
  }
  const handleCloseDialog = () => {
    // setOfferSelection("");
    setOpenDiscount();
    setPin("");
    return dispatch({
      type: "HIDE_OFFERS",
      payload: null,
    });
  };
  return (
    <Dialog
      onClose={handleCloseDialog}
      aria-labelledby="customized-dialog-title"
      open={state.showOffers}
      classes={{ root: classes.allContainer, paper: classes.paper }}
    >
      <SFDialogTitle
        id="customized-dialog-title"
        onClose={handleCloseDialog}
        title={translate("ra.text.specialOffers")}
        subtitle={translate("ra.text.canUseOnlyOneOffer")}
      />

      <DialogContent classes={{ root: classes.dialogContent }}>
        <GridList cellHeight={101} className={classes.gridList} cols={3}>
          {offers
            ? offers
                .filter((offer) => {
                  if (offer.coupons && offer.coupons.length > 0)
                    return (
                      offer.coupons[0].type === "Multiplier" ||
                      offer.coupons[0].type === "Reward"
                    );
                  else return false;
                })
                .map((offer, index) => (
                  <GridListTile key={index}>
                    <CircleToggleButtonItem
                      label={offer.name}
                      onClick={() => {
                        if (offer.id === offerSelection?.id)
                          setOfferSelection(null);
                        else setOfferSelection(offer.clone());
                        setOpenDiscount();
                      }}
                      imgUrl={offer.image_url}
                      conditions={offer.conditions}
                      selected={offer.id === offerSelection?.id}
                    />
                  </GridListTile>
                ))
            : "No special Offers"}
        </GridList>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <TextField
          label={"value"}
          variant="outlined"
          classes={{ root: classes.authorizeTextField }}
          onChange={(e) => setOpenDiscount(Math.abs(e.target.value))}
          type="number"
          value={String(openDiscount)}
          disabled={
            !offerSelection ||
            offerSelection === "" ||
            !isOfferisFreeValue(offerSelection)
          }
        ></TextField>
        <TextField
          type={showPassword ? "text" : "password"}
          label={translate("ra.text.management.authorizationCode")}
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          classes={{ root: classes.authorizeTextField }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Authorize code"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          onClick={async () => {
            if (!offerSelection) {
              dispatch({
                type: "APPLY_OFFER",
                payload: { offer: null },
              });
              return dispatch({
                type: "HIDE_OFFERS",
                payload: { offer: null },
              });
            }
            if (offerSelection.pin) {
              const result = await checkAuth({
                offerId: offerSelection?.id,
                pin: pin,
              });
              if (result.error) {
                setPin("");
                alert(translate("ra.text.wrongAuthorizeCode"));
                return;
              }
            }

            dispatch({
              type: "HIDE_OFFERS",
            });

            offerSelection.pin = pin;

            if (
              openDiscount &&
              openDiscount !== "" &&
              isOfferisFreeValue(offerSelection)
            ) {
              // const discountInfo = Object.assign(
              //   Object.create(Object.getPrototypeOf(offerSelection)),
              //   offerSelection
              // );
              offerSelection.coupons[0].value = openDiscount;
              dispatch({
                type: "APPLY_OFFER",
                payload: { offer: offerSelection },
              });
            } else {
              dispatch({
                type: "APPLY_OFFER",
                payload: { offer: offerSelection },
              });
            }
            //setOfferSelection("");
            setPin("");
            // setOpenDiscount();
          }}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
          disabled={false}
        >
          {translate("ra.text.addProduct.applySpecialOffer")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const isOfferisFreeValue = (offer) => {
  return offer.coupons[0].value === 0;
};
export default OffersDialog;
